
































































































































































































import {
	defineComponent,
	reactive,
	ref,
	Ref,
} from '@vue/composition-api';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { useConfirmDialog } from '@vueuse/core';
import { BubbleMenu } from '@tiptap/vue-2';
import { Editor } from '@tiptap/core';
import { BubbleMenuPluginProps } from '@tiptap/extension-bubble-menu';
import { Size, Spacing } from '@front-app/components/constants';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import TrModal from '@front-app/components/modals/TrModal.vue';
import SimpleCard from '@front-app/components/cards/SimpleCard.vue';
import EditButton from '@front-app/components/buttons/concrete/EditButton.vue';
import XButton from '@front-app/components/buttons/concrete/XButton.vue';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import MenuIconButton from './MenuIconButton.vue';
import { LINK } from './marks';
import TrForm from '../Form.vue';
import FormLabel from '../FormLabel.vue';
import FormInput from '../FormInput.vue';
import FormSection from '../FormSection.vue';
import { getLinkId, LinkAttrs } from './extensions/link/util';

type ActiveCheckKey = 'bold'
	| 'italic'
	| 'underline'
	| 'orderedList'
	| 'bulletList'
	| 'link'
	| 'textAlignLeft'
	| 'textAlignCenter'
	| 'textAlignRight';

interface TextAlignCheck {
	textAlign: string;
}

const EDITOR_ACTIVE_CHECKS: [ActiveCheckKey, string | TextAlignCheck][] = [
	['bold', 'bold'],
	['italic', 'italic'],
	['underline', 'underline'],
	['orderedList', 'orderedList'],
	['bulletList', 'bulletList'],
	['link', LINK],
	['textAlignLeft', { textAlign: 'left' }],
	['textAlignCenter', { textAlign: 'center' }],
	['textAlignRight', { textAlign: 'right' }],
];

export default defineComponent({
	components: {
		FontAwesomeIcon,
		MenuIconButton,
		BubbleMenu,
		TrForm,
		FormLabel,
		FormInput,
		TrModal,
		SimpleCard,
		EditButton,
		XButton,
		FormSection,
		CtaButton,
	},
	props: {
		editor: {
			type: Editor,
			required: true,
		},
		enableAlignment: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	setup(props) {
		const linkHref = ref('');
		const linkInput = ref(null) as unknown as Ref<HTMLInputElement>;
		const activeState: Record<ActiveCheckKey, boolean> = reactive({
			bold: false,
			italic: false,
			underline: false,
			orderedList: false,
			bulletList: false,
			link: false,
			textAlignLeft: false,
			textAlignCenter: false,
			textAlignRight: false,
		});
		props.editor.on('transaction', ({ editor }) => {
			EDITOR_ACTIVE_CHECKS
				.forEach(([key, check]) => {
					activeState[key] = editor.isActive(check);
				});
		});

		// Link menu
		const linkUrlLocal = ref('');
		const linkModal = useConfirmDialog();
		const shouldShowLinkMenu: BubbleMenuPluginProps['shouldShow'] = ({ editor }) => editor.isActive(LINK);
		const clearLink = () => {
			linkHref.value = '';
			props.editor.chain().focus().unsetLink().run();
		};
		const updateLink = async () => {
			const id = (props.editor.getAttributes(LINK) as LinkAttrs).id || getLinkId();
			props.editor.chain().setLink({
				id,
				href: linkUrlLocal.value,
			}).run();
			linkModal.cancel();
		};
		linkModal.onReveal(() => {
			linkUrlLocal.value = props.editor.getAttributes('link').href || 'https://';
		});
		linkModal.onCancel(() => {
			linkUrlLocal.value = '';
		});
		// END Link menu

		return {
			activeState,
			clearLink,
			updateLink,
			linkUrlLocal,
			shouldShowLinkMenu,
			linkModal,
			linkInput,
			linkHref,
			// Util
			Size,
			Spacing,
			ButtonPalettes,
		};
	},
});
